/**
 * requireOnError — the ONE reporter rule every marketing analytics transport factory obeys
 * (REQUEST-VALIDATION-CONVERGE-001 AN2).
 *
 * A transport's failure is REPORTED, never swallowed. Each factory here used to default `onError` to
 * `() => {}`, and none of the nine marketing sites passed one, so every failed send — a refused
 * ingest, a network drop, a throwing third-party tag — vanished without a line anywhere. The
 * reporter is injected and REQUIRED, and a factory built without one refuses at construction, by
 * name: the shape `@puffin-core/required-logger`'s `requireLogger` gives a missing logger.
 *
 * @module @puffin-core/marketing-shell/analytics/requireOnError
 */

/**
 * Refuse a factory built without a reporter: a TypeError naming the factory being built.
 *
 * @param {string} owner - the factory being built (`'createGa4Transport'`)
 * @param {unknown} onError - the reporter it was given
 * @returns {void}
 * @throws {TypeError} when `onError` is not a function
 */
export default function requireOnError(owner, onError) {
  if (typeof onError !== 'function') {
    throw new TypeError(
      `${owner}: onError (error) => void is required — a transport failure is reported, never swallowed`,
    );
  }
}
